import createVueApp from '@phoenix/createVueApp';
import FindYourFitModal from '@maison/components/FindYourFitModal.vue';

if (document.getElementById('phoenix-find-your-fit-modal')) {
  const app = createVueApp();
  app.component('FindYourFitModal', FindYourFitModal);
  app.mount('#phoenix-find-your-fit-modal');
}
